import MatchingInformationBetaBanner from './MatchingInformationBetaBanner.component';

export default MatchingInformationBetaBanner;